import {
  SET_SPIN
} from './types';

const initialState = {
  globalSpin: false
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case SET_SPIN:
      return { ...state, globalSpin: payload };
    default:
      return state;
  }
};